import Router from "./pages/shared/router";
import SessionTimeout from "./pages/shared/SessionTimeout";

function App() {
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login"; // redirect user
  };

  return (
    <>
      {/* Session Timeout always running globally */}
      <SessionTimeout onLogout={handleLogout} />

      {/* Your router */}
      <Router />
    </>
  );
}

export default App;
